import styled from 'styled-components';

export const DatePickerWrapper = styled.div<{ top?: number; left?: number }>`
  position: absolute;
  top: ${(props) => props.top ?? 0}px;
  left: ${(props) => props.left ?? 0}px;
  @media (max-width: 450px) {
    left: 0;
  }
`;

export const NavigationButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  vertical-align: middle;
  padding: 2px;
`;

export const OpenButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  vertical-align: middle;
  padding: 3px;
  margin-right: 10px;
`;
